import { Tabs } from "antd";
import { useState } from "react";
import TopNav from "ui/dashboard/topnav";
import { OpenApi } from "./openapi";
import { WebHook } from "./webhook";

// dayjs.tz.setDefault("Europe/Berlin");
const items = [
  {
    label: "Open API",
    key: "openapi",
  },
  {
    label: "WebHook",
    key: "webhook",
  },
];
export default function Page() {
  const [activeKey, setActiveKey] = useState("openapi");
  return (
    <>
      <TopNav title="OpenApi" />
      <div className="flex h-full flex-col md:flex-row md:overflow-hidden bg-white rounded-3xl mr-6 mb-6">
        <div className="w-full flex-none overflow-y-auto border-r border-neutral-200 p-5 ">
          <Tabs activeKey={activeKey} onChange={setActiveKey} items={items} />
          {activeKey === "openapi" && <OpenApi />}
          {activeKey === "webhook" && <WebHook />}
        </div>
      </div>
    </>
  );
}
